import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function TermsAndConditions() {
    return (
        <>
                    <Helmet>
                <title>
                    Terms & Conditions | Al Ibtekar Technical Solutions FZC
                </title>

                <meta
                    name="description"
                    content="Read the Terms & Conditions of Al Ibtekar Technical Solutions FZC covering quotations, orders, payments, delivery, returns, warranties, intellectual property, confidentiality and applicable UAE laws."
                />

                <meta
                    name="robots"
                    content="index, follow"
                />

                <link
                    rel="canonical"
                    href="https://saig.me/terms-and-conditions"
                />

                <meta
                    property="og:title"
                    content="Terms & Conditions | Al Ibtekar Technical Solutions FZC"
                />

                <meta
                    property="og:description"
                    content="Review the terms and conditions governing the use of the Al Ibtekar website, quotations, orders, payments, delivery, warranties and business transactions."
                />

                <meta
                    property="og:url"
                    content="https://saig.me/terms-and-conditions"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Al Ibtekar"
                />

                <meta
                    name="twitter:card"
                    content="summary"
                />

                <meta
                    name="twitter:title"
                    content="Terms & Conditions | Al Ibtekar Technical Solutions FZC"
                />

                <meta
                    name="twitter:description"
                    content="Read Al Ibtekar's Terms & Conditions regarding orders, payments, delivery, returns, warranties and applicable UAE laws."
                />
            </Helmet>

        <section
            style={{
                background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)`,
            }}
        >
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
                viewport={{ once: true }}
                className="max-w-5xl mt-[92px] mx-auto px-4 py-10 font-kanit text-gray-800"
            >
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true }}
                    className="text-3xl font-bold mb-6"
                >
                    Terms & Conditions
                </motion.h1>

                {[
                    {
                        title: '1. Acceptance of Terms',
                        desc: 'By using our website, communicating with us, or placing orders, you agree to these Terms & Conditions as per the UAE Federal Commercial Law and applicable Free Zone regulations.',
                    },
                    {
                        title: '2. Business Scope',
                        desc: 'Al Ibtekar Technical Solutions FZC offers cable management systems, labeling, custom enclosures, and integration services throughout the UAE and GCC region. Services may vary based on availability and project needs.',
                    },
                    {
                        title: '3. Quotations & Pricing',
                        desc: 'All quotes are valid for the period mentioned in the quotation. Prices are in AED and exclusive of UAE VAT (currently 5%) unless stated. Shipping and handling are calculated separately.',
                    },
                    {
                        title: '4. Orders & Payment Terms',
                        desc: 'Orders are confirmed via email or official purchase orders. Payment terms (e.g., 50% advance, 50% on delivery) are stated in the invoice. Invoices are issued in accordance with UAE VAT laws.',
                    },
                    {
                        title: '5. Delivery & Risk Transfer',
                        desc: 'Delivery dates are estimated. Al Ibtekar is not liable for delays beyond our control. Risk passes to the buyer upon dispatch or delivery, depending on agreed INCOTERMS (e.g., EXW, DDP).',
                    },
                    {
                        title: '6. Returns & Warranty',
                        desc: 'Returns are accepted only for defective items reported within 7 working days of delivery. Custom-manufactured goods are not returnable unless proven faulty. Product warranties follow manufacturer terms.',
                    },
                    {
                        title: '7. Third-Party Websites',
                        desc: 'Our website may include links to third-party websites. We do not control or endorse their content, and we disclaim liability for their policies or practices.',
                    },
                    {
                        title: '8. Intellectual Property',
                        desc: 'All logos, designs, content, and documents are the intellectual property of Al Ibtekar and may not be copied or reused without written permission.',
                    },
                    {
                        title: '9. Limitation of Liability',
                        desc: 'Al Ibtekar shall not be liable for indirect, incidental, or consequential losses including project delays, revenue loss, or damages arising from misuse or third-party installation.',
                    },
                    {
                        title: '10. Confidentiality',
                        desc: 'All client information, drawings, and project documents are treated as confidential. We do not share your data with external parties unless required by UAE law.',
                    },
                    {
                        title: '11. Compliance with UAE Law',
                        desc: 'All transactions and business conduct are subject to the laws of the United Arab Emirates, including applicable Free Zone regulations and the UAE Civil Transactions Law.',
                    },
                    {
                        title: '12. Force Majeure',
                        desc: 'We are not liable for delays or failures due to force majeure events such as natural disasters, pandemics, strikes, or government restrictions.',
                    },
                    {
                        title: '13. Dispute Resolution',
                        desc: 'Any disputes shall be resolved under the jurisdiction of the courts in Sharjah, UAE or as governed by the relevant Free Zone authority.',
                    },
                    {
                        title: '14. Updates to Terms',
                        desc: 'Al Ibtekar reserves the right to modify these Terms & Conditions at any time. Changes will be posted on our website with the updated date.',
                    },
                ].map((item, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: 0.1 * index }}
                        viewport={{ once: true }}
                    >
                        <h2 className="text-xl font-semibold mt-6 mb-2">{item.title}</h2>
                        <p className="mb-4">{item.desc}</p>
                    </motion.div>
                ))}

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: 0.2 }}
                    viewport={{ once: true }}
                    className="mt-10 text-sm text-gray-500"
                >
                    Last Updated: July 2025
                </motion.p>
            </motion.div>
        </section>
        </>

    );
}

export default TermsAndConditions;
